import React, { useCallback, useContext, useEffect, useReducer, useState, useRef } from "react";
import { Input, List, Modal, Avatar, Tabs, message, Empty, Select, Button, Radio } from "antd";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import logger from "@/utils/logger";
import { useTranslation } from "@/components/Joyspace/context";
import "./index.less";
import IconFont from "@/components/icon";
import TabPaneCloud from "./panels/TabPanelCloud";
import TabPaneSearch from "./panels/TabPanelSearch";
import TabPanePersonal from "./panels/TabPanelPersonal";
import TabPanelTeamSpace from "./panels/TabPanelTeamSpace";
import TabPanelCollections from "./panels/TabPanelCollections";
import PageList from "./PageList";
import { initState, reducer, StoreContext } from "./store";
import { StateActionNames } from "./types";
import { buildDeepLink } from "./utils";
import { changeEgovUrl } from "@/utils/tools";
import { duccConfigI18 } from "@/utils/i18n";
import TabPanelGroupSpace from "./panels/TabPanelGroupSpace";

const { Option } = Select;
const log = logger.getLogger("JoyspaceFileSelectorModal");

interface IGroupInfo {
  gid: string;
}

export default function JoyspaceFileSelectorModal(props: any) {
  const t = useTranslation();
  const [state, dispatch] = useReducer(reducer, initState);
  const { focusSDK } = useContext<GlobalContextConfig>(GlobalContext);
  const [searchValue, setSearchValue] = useState<string>("");
  const [modalVisible, setModalVisible] = useState(false);
  const [callbackId, setCallbackId] = useState("");
  const [cloudTitle, setCloudTitle] = useState("selector.title");
  const chatCbk = useRef<any>();
  const [filterType, setFilterType] = useState<string>("open_time");
  const [isGroupspace, setIsGroupspace] = useState<boolean>(false);
  const [groupInfo, setGroupInfo] = useState<IGroupInfo | null>(null);
  const [canSelectPermission, setCanSelectPermission] = useState<boolean>(true);
  const [isChange, setIsChange] = useState(false);
  const filterOptions = [
    {
      value: "open_time",
      label: t("selector.filterItem.openTime")
    },
    {
      value: "modified_time",
      label: t("selector.filterItem.modifiedTime")
    }
  ];

  const onClose = useCallback(() => {
    setModalVisible(false);
    // modalVisibleCurrent.current = false;
    setSearchValue("");
    focusSDK.emit("openJoyspaceDocSelector:result", {
      status: "cancel",
      callbackId: callbackId
    });
    setIsGroupspace(false);
    setGroupInfo(null);
    setCanSelectPermission(true);
    dispatch({ action: StateActionNames.CLEAR_SELECTED });
  }, [focusSDK, callbackId]);

  const handleModalOk = useCallback(() => {
    // modalVisibleCurrent.current = false;
    console.log("cloudTitle~~~", cloudTitle);
    if (cloudTitle !== "selector.cloudTitle") {
      console.log(
        "focusSDK.listenerCount~~~~",
        focusSDK.listenerCount("openJoyspaceDocSelector:result")
      );
      console.log(
        "focusSDK.listenerCount~~~~",
        focusSDK.listeners("openJoyspaceDocSelector:result")
      );
      if (typeof chatCbk.current === "function") {
        chatCbk.current({
          status: "ok",
          callbackId: callbackId,
          results: state.selectedItems.map((item) => ({
            id: item.id,
            title: item.title,
            pageType: item.pageType,
            type: item.mimeType,
            link: item.link,
            permissionType: item.permissionType,
            icon: changeEgovUrl(item.iconUrl),
            linkH5: item.linkH5 || buildDeepLink(item.id, item.pageType),
            from: groupInfo ? "groupspace" : "joyspace"
          }))
        });
      }
    } else {
      // console.log('chatCbk', typeof chatCbk.current);
      if (typeof chatCbk.current === "function") {
        chatCbk.current(
          state.selectedItems.map((item) => ({
            id: item.id,
            title: item.title,
            pageType: item.pageType,
            type: item.mimeType,
            link: item.link,
            permissionType: item.permissionType,
            icon: changeEgovUrl(item.iconUrl),
            linkH5: item.linkH5 || buildDeepLink(item.id, item.pageType),
            from: groupInfo ? "groupspace" : "joyspace"
          }))
        );
      }
    }
    if (!isGroupspace) {
      setModalVisible(false);
      setSearchValue("");
      dispatch({ action: StateActionNames.CLEAR_SELECTED });
    }
  }, [focusSDK, callbackId, state, cloudTitle, chatCbk]);

  const handleOpenJoyspaceDocSelector = useCallback(
    (data: {
      callbackId: string;
      max?: number;
      groupInfo?: IGroupInfo;
      callback?: () => {};
      controlMethod?: Function;
      canSelectPermission?: boolean;
    }) => {
      setCloudTitle("selector.title");
      setCallbackId(data?.callbackId || "");
      let noop = () => {};
      console.log("data.callback", data?.callback);
      chatCbk.current = data?.callback || noop;
      dispatch({ action: StateActionNames.SET_MAX, max: data?.max || -1 });
      dispatch({ action: StateActionNames.SET_CONTROL_METHOD, func: data?.controlMethod || null });
      // setModalVisible(true);
      setCanSelectPermission(data.canSelectPermission ?? true);
      if (data.groupInfo) {
        setIsGroupspace(true);
        setGroupInfo(data.groupInfo);
        setCanSelectPermission(false);
      }

      // modalVisibleCurrent.current = true;
      setModalVisible(true);
    },
    [setCallbackId, dispatch, setCloudTitle]
  );

  const handleOpenJoyspaceCloudSelector = useCallback(
    (data: { callbackId: string; max?: number; callback?: () => {}; groupInfo?: IGroupInfo }) => {
      setCloudTitle("selector.cloudTitle");
      setCallbackId(data?.callbackId || "");
      let noop = () => {};
      console.log("data.callback", data?.callback);
      chatCbk.current = data?.callback || noop;
      // setModalVisible(true);
      if (data.groupInfo) {
        setIsGroupspace(true);
        setGroupInfo(data.groupInfo);
      }
      // modalVisibleCurrent.current = true;
      setModalVisible(true);
    },
    [setCallbackId, dispatch, setCloudTitle]
  );

  useEffect(() => {
    focusSDK
      .off("openJoyspaceDocSelector", handleOpenJoyspaceDocSelector)
      .on("openJoyspaceDocSelector", handleOpenJoyspaceDocSelector);
    focusSDK
      .off("openJoyspaceCloudSelector", handleOpenJoyspaceCloudSelector)
      .on("openJoyspaceCloudSelector", handleOpenJoyspaceCloudSelector);
    focusSDK.off("closeJoyspaceDocSelector", onClose).on("closeJoyspaceDocSelector", onClose);
    return () => {
      focusSDK.off("openJoyspaceDocSelector", handleOpenJoyspaceDocSelector);
      focusSDK.off("openJoyspaceCloudSelector", handleOpenJoyspaceCloudSelector);
      focusSDK.off("openJoyspaceDocSelector", onClose);
    };
  }, [focusSDK, handleOpenJoyspaceDocSelector, handleOpenJoyspaceCloudSelector]);

  useEffect(() => {
    if (state.errorType) {
      message.error(t(state.errorType).replace("__count__", `${state.max}`));
      dispatch({ action: StateActionNames.CLEAR_ERROR_TYPE });
    }
  }, [state, t, dispatch]);

  return (
    <Modal
      title={t(cloudTitle, {
        joyspace: duccConfigI18.joyspace
      })}
      destroyOnClose
      width="800"
      visible={modalVisible}
      onCancel={onClose}
      onOk={handleModalOk}
      okText={t("confirm")}
      cancelText={t("cancel")}
      wrapClassName="modalAutoFillHeight joyspace-file-selector-modal"
      zIndex={1050}
    >
      <StoreContext.Provider value={[state, dispatch]}>
        <div className="selector-sources">
          <div className="selector-sources-search">
            <Input.Search
              prefix={<IconFont className="prefix-icon" type="iconapp_ic_search" />}
              placeholder={t("selector.search.placeholder")}
              allowClear
              onSearch={(value) => {
                setSearchValue(value);
              }}
              onChange={(event: any) => {
                setSearchValue(event.target.value);
              }}
              onCompositionStart={() => {
                setIsChange(true);
              }}
              onCompositionEnd={(event: any) => {
                setSearchValue(event.target.value);
                setIsChange(false);
              }}
            />
          </div>
          {searchValue && (
            <TabPaneSearch
              key="search"
              search={searchValue}
              isChange={isChange}
              groupInfo={groupInfo}
            />
          )}
          {!searchValue && !isGroupspace && (
            <Tabs className="selector-sources-tabs">
              <Tabs.TabPane key="joyspace" tab={t("home.tabs.recent")}>
                <Radio.Group
                  defaultValue={filterType}
                  buttonStyle="solid"
                  className="selector-data-recent-filter"
                  size="small"
                  onChange={(e: any) => {
                    setFilterType(e.target.value);
                  }}
                >
                  {filterOptions.map((item: any) => {
                    return (
                      <Radio.Button key={item.value} value={item.value}>
                        {item.label}
                      </Radio.Button>
                    );
                  })}
                </Radio.Group>
                <TabPaneCloud key="joyspace" filterType={filterType} />
              </Tabs.TabPane>
              <Tabs.TabPane key="myspace" tab={t("myspace.title")}>
                <TabPanePersonal key="myspace" />
              </Tabs.TabPane>
              <Tabs.TabPane key="teamspace" tab={t("teamspace.title")}>
                <TabPanelTeamSpace key="teamspace" />
              </Tabs.TabPane>
              <Tabs.TabPane key="collections" tab={t("collections.title")}>
                <TabPanelCollections key="collections" />
              </Tabs.TabPane>
            </Tabs>
          )}
          {!searchValue && isGroupspace && <TabPanelGroupSpace groupInfo={groupInfo} />}
        </div>
        <div className="selected-files">
          <div className="selected-files-box">
            <PageList value={[state, dispatch]} canSelectPermission={canSelectPermission} />
          </div>
          {/* <List
                        className="selected-files-body"
                        split={false}
                        locale={{
                            emptyText: (
                                <Empty
                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                    description={t('no data')}
                                />
                            ),
                        }}
                        renderItem={(item) => (
                            <List.Item
                                className="selected-files-item"
                                key={item.id}
                                actions={[
                                    <IconFont
                                        key="remove selected"
                                        className="iconapp_btn_alert_cancel"
                                        type="iconapp_btn_alert_cancel"
                                        onClick={() => {
                                            dispatch({
                                                action: StateActionNames.TOGGLE_SELECTED,
                                                item,
                                            });
                                        }}
                                    />,
                                ]}
                            >
                                <List.Item.Meta
                                    avatar={
                                        <Avatar
                                            size={40}
                                            shape="square"
                                            src={changeEgovUrl(item.iconUrl)}
                                        />
                                    }
                                    title={item.title || t('untitled')}
                                />
                            </List.Item>
                        )}
                        dataSource={state.selectedItems}
                    /> */}
        </div>
      </StoreContext.Provider>
    </Modal>
  );
}
